<div [ngClass]="classList">
  <app-chips-input
    [label]="label"
    [placeholder]="placeholder"
    [aria-label]="ariaLabel"
    [items]="items"
    (chipsInputChanged)="onChange($event)">
  </app-chips-input>
</div>
